import { HttpInterceptorFn } from '@angular/common/http';
// import {environment} from "@app/environments/environment.qa";
import {environment} from "@app/environments/environment";

export const baseUrlInterceptor: HttpInterceptorFn = (req, next) => {
  const shouldPrependForwardSlash = req.url.charAt(0) !== '/';

  const finalUrl = shouldPrependForwardSlash
    ? `${environment.BASEURL}/${req.url}`
    : `${environment.BASEURL}${req.url}`;

  const newReq = req.clone({
    url: finalUrl,
  });

  return next(newReq);
};
